import React, { useState } from "react";
import { message, Card, Button, Row, Col, Space, Typography } from "antd";
import intl from "react-intl-universal";
import { genTokenIdApi, getCountriesApi, getTypeV2Api } from "@/services/auth";
import { getUserInfoToLocal } from "@/utils/auth";
import { setLoginTagApi } from "@/services/common";
import cloudImg from "@/image/cloud1.png";
import collectImg from "@/image/collect1.png";
import examImg from "@/image/exam1.png";
import gaiImg from "@/image/gai1.png";
import picImg from "@/image/pic1.png";
import voiceImg from "@/image/voice1.png";

const getQuickAccessButtons = () => [
  {
    key: "collect",
    label: intl.get("Collection"),
    desc: intl.get("Collection_desc"),
    icon: collectImg,
    color: "#3C8F8F",
    path: "/collection",
    hidden: getUserInfoToLocal().isLimit
  },
  {
    key: "voiceText",
    label: intl.get("VoiceText_Annotation"),
    desc: intl.get("VoiceText_desc"),
    icon: gaiImg,
    color: "#6B5B8C",
    loginForm: "TTS",
    url: process.env.REACT_APP_TTS_URL,
  },
  {
    key: "pointCloud",
    label: intl.get("Point_cloud_annotation"),
    desc: intl.get("Point_cloud_desc"),
    icon: cloudImg,
    color: "#6B5B8C",
    loginForm: 1,
    url: process.env.REACT_APP_VDS_URL,
  },
  {
    key: "imageVideo",
    label: intl.get("ImageVideo_Annotation"),
    desc: intl.get("ImageVideo_desc"),
    icon: picImg,
    color: "#6B5B8C",
    loginForm: 1,
    url: process.env.REACT_APP_VDS_URL,
  },
  {
    key: "voiceFactory",
    label: intl.get("Voice_Actor_Factory"),
    desc: intl.get("Voice_Actor_desc"),
    icon: voiceImg,
    color: "#7D5E5E",
    path: "/voice",
    hidden: getUserInfoToLocal().isLimit
  },
  {
    key: "exam",
    label: intl.get("Exam_preparation_training"),
    desc: intl.get("Exam_preparation_desc"),
    icon: examImg,
    color: "#5B7D4E",
    path: "/dots-exam",
    hidden: getUserInfoToLocal().isLimit
  },
];

export const QuickActions = () => {
  const onActionClick = async (item) => {
    if (item.path) {
      window.location.href = window.location.origin + item.path;
      return;
    }
    const token = await genTokenId();
    if (getUserInfoToLocal().userType == 1) {
      setLoginTagApi(getUserInfoToLocal().id, item.loginForm).then((res) => {
        if (res.code === 0) {
          if (item.url) {
            window.location.href = item.url + token;
          }
        } else {
          message.error(res.message);
        }
      });
    } else {
      if (item.url) {
        window.location.href = item.url + token;
      }
    }
  };

  // 获取token
  const genTokenId = () => {
    return new Promise((resolve, reject) => {
      genTokenIdApi().then((res) => {
        console.log(res);
        if (res.code === 0) {
          resolve(res.data);
        } else {
          message.error(res.message);
          return;
        }
      });
    });
  };
  const [hoveredKey, setHoveredKey] = useState("");
  return (
    <>
      {!(
        getUserInfoToLocal().userType == 2 &&
        (JSON.parse(localStorage.supplierbase).supplierStatus == 1 ||
          JSON.parse(localStorage.supplierbase).supplierStatus == 5)
      ) && (
        <div
          style={{
            padding: 24,
            margin: "0 auto",
          }}
        >
          <p
            style={{
              height: "23px",
              fontWeight: 400,
              color: "#000000",
              lineHeight: "20px",
            }}
          >
            快速操作
          </p>

          <div style={{ display: "flex", flexDirection: "column" }}>
            {getQuickAccessButtons().filter(ite => !ite.hidden).map((button) => (
              <div
                style={{
                  height: "27px",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor:
                    hoveredKey === button.key ? "#f0f9ff" : "transparent",
                }}
                key={button.key}
                onMouseEnter={() => setHoveredKey(button.key)}
                onMouseLeave={() => setHoveredKey("")}
                onClick={() => onActionClick(button)}
              >
                <img src={button.icon} style={{ width: 20, height: 20 }} />
                <span
                  style={{
                    fontWeight: 400,
                    color: "#1890FF",
                    lineHeight: "20px",
                    marginLeft: "18px",
                    overflow: "hidden",
                    flex: 1,
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    minWidth: 0,
                  }}
                >
                  {button.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default QuickActions;
